import React, { useState } from 'react';

import MainView from '@/modules/Blog/components/Main/MainView';

const Main = () => {
  return <MainView />;
};

export default Main;
